/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Waiting/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Appointments from './Appointments/index'
import MinimiseAction from './MinimiseAction/index'
import React from 'react'
import Tabs from './Tabs/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconHourglassBottom from 'DesignSystem/Svgs/TysiaIconHourglassBottom/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Waiting({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Waiting"
  
}) {
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Waiting.Vertical"
  data-view-path={viewPath}
 style={{'--bc-5-Z1Mla65': dtColorsWhite,'--bc-6-Z1Mla65': dtColorsNeutral400,'--mb-7-Z1Mla65': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--fg-1-Z1Mla65': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? 0 : 1,'--fs-2-Z1Mla65': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? 0 : 1,'--fb-3-Z1Mla65': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? "auto" : "100%",'--w-4-Z1Mla65': isMedia.mobile ? "100%" : "250px"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Waiting.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-8-Z1Mla65': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-Z1Mla65': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbc-10-Z1Mla65': dtColorsNeutral400,'--bc-5-Z1Mla65': dtColorsWhite,'--bbw-11-Z1Mla65': flow.has(fromFlow.normalizePath(viewPath, 'Appointments/No')) ? "0px" : "1px"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconHourglassBottom
  viewPath={`${viewPath}/TysiaIconHourglassBottom`}
 width={16}
 height={16}
 fill={dtColorsNeutral900}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h5"
 marginLeft={4}
 text="Waiting"
/>
<Tabs
  viewPath={`${viewPath}/Tabs`}
/>
<MinimiseAction
  viewPath={`${viewPath}/MinimiseAction`}
/>
</div>
<Appointments
  viewPath={`${viewPath}/Appointments`}
/>
</div>
{children}
</React.Fragment>)
}